<div class="row">
  <div *ngIf="showThumbnails" class="col-3 col-xl-2 pr-sm-0">
    <a *ngIf="linkType !== linkTypes.None" [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'"
       [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null"
       [routerLink]="[itemPageRoute]" class="dont-break-out" role="link" tabindex="-1">
      <ds-thumbnail [thumbnail]="dso?.thumbnail | async"
                           [defaultImage]="'assets/images/person-placeholder.svg'"
                           [alt]="'thumbnail.person.alt'"
                           [placeholder]="'thumbnail.person.placeholder'">
      </ds-thumbnail>
    </a>
    <span *ngIf="linkType === linkTypes.None" class="dont-break-out">
      <ds-thumbnail [thumbnail]="dso?.thumbnail | async"
                    [defaultImage]="'assets/images/person-placeholder.svg'"
                    [alt]="'thumbnail.person.alt'"
                    [placeholder]="'thumbnail.person.placeholder'">
      </ds-thumbnail>
    </span>
  </div>
  <div [ngClass]="showThumbnails ? 'col-9 col-xl-10' : 'col-12'">
    <div class="d-flex justify-content-between">
      <div class="flex-fill">
        <ds-badges *ngIf="showLabel" [object]="dso" [context]="context"></ds-badges>
        <ds-truncatable [id]="dso.id">
      <a *ngIf="linkType !== linkTypes.None" [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'"
         [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null"
           [routerLink]="[itemPageRoute]" class="lead"
         [innerHTML]="dsoTitle || ('person.listelement.no-title' | translate)" role="link" tabindex="0"></a>
      <span *ngIf="linkType === linkTypes.None"
              class="lead"
              [innerHTML]="dsoTitle || ('person.listelement.no-title' | translate)"></span>
        <div class="text-muted">
            <ds-truncatable-part [id]="dso.id" [minLines]="1">
            <div *ngIf="dso.allMetadata(['person.jobTitle']).length > 0"
                  class="item-list-job-title">
              <span *ngFor="let value of allMetadataValues(['person.jobTitle']); let last=last;">
                <span [innerHTML]="value"></span>
              </span>
            </div>
          </ds-truncatable-part>
        </div>
        <ds-additional-metadata [object]="dso"></ds-additional-metadata>
        </ds-truncatable>
        <ds-metric-badges *ngIf="showMetrics" class="d-block clearfix" [item]="dso"></ds-metric-badges>
      </div>
      <div class="align-self-center" *ngIf="showMetrics">
        <ds-metric-donuts [item]="dso"></ds-metric-donuts>
      </div>
    </div>
  </div>
</div>

